import React from "react"
export function PassportLoss(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M13.13 8.316c2.69 0 4.87 2.168 4.87 4.842C18 15.832 15.82 18 13.13 18c-2.689 0-4.87-2.168-4.87-4.842 0-2.674 2.181-4.842 4.87-4.842zm0 .908c-2.185 0-3.956 1.761-3.956 3.934s1.771 3.934 3.956 3.934c2.186 0 3.957-1.761 3.957-3.934s-1.771-3.934-3.957-3.934zm.57-6.307c.024.096.037.195.037.294v.967c.58.224 1.003.76 1.06 1.402l.007.15v1.364h-.913V5.73l-.004-.077a.759.759 0 00-.651-.672l-.106-.007H4.913v10.152h1.979v.908H4.457l-.062-.004a.456.456 0 01-.387-.366L4 15.58V4.08l8.224-2.043a1.218 1.218 0 011.476.881zm-1.955 8.195l1.399 1.397 1.396-1.396.645.646-1.396 1.395 1.4 1.4-.643.643-1.399-1.4-1.385 1.386-.646-.646 1.386-1.386-1.399-1.398.642-.641zm.168-4.611v.907h-4.87v-.907h4.87zm.587-3.592l-.055.008-4.617 1.147h4.995v-.853a.304.304 0 00-.324-.302z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__passport-loss"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
